<template>
  <div id="quiz-permission">
    <div class="permission-title mb-2">
      {{ formData.headerName }}
    </div>
    <b-row>
      <b-col cols="12">
        <b-form-radio
          v-model="formData.selected"
          name="mode-radios"
          :value="1"
          class="font-medium-3 custom-radio-group text-black"
          :class="{ bypass: isDisabled }"
          >Tag Permission</b-form-radio
        >
        <div class="custom-ml font-medium-3 text-black">
          <div>
            <span>กรุณากำหนดสิทธิ์ของสมาชิก ที่</span
            ><span class="text-black font-medium-3 text-under"
              ><b>สามารถมองเห็น และ</b>
            </span>
            <b>{{ formData.descTag }}</b>
          </div>
          <div class="text-black mt-2 permission-header">สิทธิ์การมองเห็น</div>
          <div class="text-black">
            <span class="mr-1 text-under">สมาชิกที่กำหนดเท่านั้น</span
            ><b>{{ formData.descVisibility }}</b>
            <!-- <img
              src="~@/assets/images/icons/IconQuestion.png"
              alt=""
              class="ml-2"
              width="15"
            /> -->
          </div>
          <b-row class="">
            <b-col cols="12">
              <v-select
                v-model="formData.visibility"
                multiple
                :reduce="(option) => option.label"
                :options="tagOption.visibilityTagOption"
                @input="onSelectTagVisibility(formData.visibility)"
                class="select-format-container tag-dropdown"
                :class="[
                  formData.visibility ? 'select-format-selected' : null,
                  { bypass: isDisabled },
                ]"
              />
            </b-col>
          </b-row>
          <div class="row text-black mt-2">
            <b-col class="permission-header"> สิทธิ์การใช้งาน </b-col>
            <b-col class="d-flex align-items-center justify-content-end">
              <b-form-checkbox
                v-model="formData.duplicate"
                class="mr-0 text-black font-medium-3 custom-control-success"
                name="is-rtl"
                inline
                @input="onInputDuplicateTag(formData.duplicate)"
                :class="formData.visibility.length == 0 ? 'bypass' : ''"
                :disabled="formData.visibility.length == 0"
              />
              <b>ใช้ข้อมูลเดียวกับการมองเห็น</b>
            </b-col>
          </div>
          <div class="text-black">
            <span class="mr-1 text-under text-black"
              >สมาชิกที่กำหนดเท่านั้น</span
            ><b>{{ formData.descPermission }}</b>
            <!-- <img
              src="~@/assets/images/icons/IconQuestion.png"
              alt=""
              class="ml-2"
              width="15"
            /> -->
          </div>
          <b-row class="">
            <b-col cols="12">
              <v-select
                v-model="formData.permission"
                multiple
                :label="'label'"
                :options="tagOption.permissionOption"
                class="select-format-container tag-dropdown"
                :class="[
                  formData.permission ? 'select-format-selected' : null,
                  { bypass: isDisabled },
                ]"
              >
                <template #no-options>
                  กรุณากำหนดสิทธิ์การมองเห็น ก่อนเลือกสิทธิ์การใช้งาน
                </template>
              </v-select>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  onBeforeMount,
  reactive,
  ref,
  getCurrentInstance,
} from "@vue/composition-api";
export default {
  props: {
    formData: {
      type: Object,
      default: {},
    },
    tagOption: {
      type: Object,
      default: {},
    },
    isDisabled: { type: Boolean, default: false },
  },
  setup(props) {
    const permissionForm = reactive({
      duplicate: [],
    });
    const vm = getCurrentInstance().proxy;

    const onSelectTagVisibility = (selectTag) => {
      permissionForm.duplicate = selectTag;
      vm.$emit("onSelectTagVisibility", permissionForm.duplicate);
    };

    const onInputDuplicateTag = (isDuplicate) => {
      vm.$emit("onInputDuplicateTag", isDuplicate);
    };

    return {
      onSelectTagVisibility,
      onInputDuplicateTag,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/quiz/permission.css";
</style>>
